module.exports = __webpack_public_path__ + "img/Logo.7341e0ad.svg";